import BrandMark from '@ui/BrandMark'
import { type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  title: string
  subtitle?: string
  children: ReactNode
}

/** The branded card every sign-in screen sits in. */
const LoginCard = ({ title, subtitle, children }: Props) => {
  const { t } = useTranslation()
  return (
    <main className="min-h-dvh bg-cream-bg grid place-items-center px-4 py-8">
      <div className="w-full max-w-[420px] bg-paper rounded-xl shadow-lg overflow-hidden">
        <div className="bg-green-900 text-white px-6 py-8 flex items-center gap-4">
          <BrandMark size="xl" className="bg-paper rounded-lg p-1" />
          <div className="leading-tight">
            <div className="font-display font-extrabold text-2xl tracking-tight">
              {t('brand.name')}
            </div>
            <div className="text-xs uppercase tracking-caps text-green-100/80">
              {t('brand.tagline')}
            </div>
          </div>
        </div>

        <div className="px-6 py-7 flex flex-col gap-5">
          <div>
            <h1 className="font-display font-bold text-2xl tracking-tight text-ink-900">
              {title}
            </h1>
            {subtitle && (
              <p className="text-sm text-ink-500 mt-1">{subtitle}</p>
            )}
          </div>
          {children}
          <p className="text-xs text-ink-500 text-center mt-2">
            {t('auth.login.footer')}
          </p>
        </div>
      </div>
    </main>
  )
}

export default LoginCard
